// extracted by mini-css-extract-plugin
export default {"awardsSection":"awardsSection_awardsSection__z25IN","awardsWrap":"awardsSection_awardsWrap__25MU4"};